import { Component,  Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'expandable-bar-wrapper',
    template: `
<div class="expandable">
  <div class="header" (click)="toggleCollapse()" [ngClass]="{collapse: collapseObject[collapseStateId] === 'collapse'}">
    <icon class="arrow" [matIcon]="(collapseObject[collapseStateId] === 'collapse' ? 'arrow_right':'arrow_drop_down')"></icon>
    <div *ngIf="header" class="date">{{ header }}</div>
  </div>
  <div class="holder" [@drop]="collapseObject[collapseStateId]"><ng-content></ng-content></div>
</div>
`,
    styleUrls: ['./expandable-bar-wrapper.scss'],
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')]),
            transition('undefined => *', [animate('0ms')])
        ])
    ],
    standalone: true,
    imports: [IconComponent, CommonModule, ],
})
export class ExpandableBarWrapperComponent {
  @Input() collapseObject: { [key: string]: 'collapse' | 'expand' } = {} // the parent object that can be mutated by this component to change the collapse state
  @Input() collapseStateId = 'anyId'
  @Input() header

  toggleCollapse() {
    const state = this.collapseObject[this.collapseStateId]
    this.collapseObject[this.collapseStateId] = state === 'collapse' ? 'expand' : 'collapse'
  }


}



